/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,400;0,500;0,700;1,400&display=swap);li[class^=ui-timepicker]{padding:8px;color:#646464}li[class^=ui-timepicker]:hover{background:#21d196}li.ui-timepicker-selected{background:#21d196!important;color:#fff!important}.timepicker-input{display:block;width:100%;padding:.375rem .75rem;font-size:14px;height:40px;color:#1a3349;background:#f8f9fc;border:1px solid #e9ebf4;border-radius:6px}.timepicker-input.ng-invalid.ng-touched{border:1px solid red}"];
export { styles as styles };
